import React from 'react';
import './DishCard.css';

function DishCard({ dish, loading = 'lazy' }) {
  const { name, description, imagePath, price, altText } = dish;

  return (
    <div className="dish-card">
      {imagePath ? (
        <img 
          src={imagePath} 
          alt={altText} 
          className="dish-card__image"
          loading={loading}
        />
      ) : (
        <div className="dish-card__placeholder">
          <span className="dish-card__placeholder-text">{name}</span>
        </div>
      )}
      <div className="dish-card__content">
        <h3 className="dish-card__name">{name}</h3>
        <p className="dish-card__description">{description}</p>
        <span className="dish-card__price">{price}</span>
      </div>
    </div>
  );
}

export default DishCard;
